export enum WorkflowConfigFilter {
    LATEST_VERSION = 'latestVersion'
}
